<template>
  <div class="invest container">
    <div class="row">
      <div class="col-lg-12">
        <loader v-show="isLoading"/>
        <div v-if="!isLoading" class="container">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <before-form-header class="header-table over-header" :title="this.strategyId ? 'views.createautoinvest.updateStrategy' : 'views.createautoinvest.createNewStrategy'" description='views.createautoinvest.strategyHeaderDescription'/>
              <div class="income-box">
                <b-button class="btn btn-sm blue-filter" v-b-toggle.sidebar-filters>Filters</b-button>
                <b-sidebar id="sidebar-filters" class="sdb" title="Filters" shadow>
                  <template #header="{ hide }">
                    <div>
                      <strong id="sidebar-filters___title__">Filters</strong>
                      <div class="right">
                        <button type="button" aria-label="Close" class="close text-dark" @click="hide">
                          <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="x" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-x b-icon bi">
                            <g><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                            </path></g></svg>
                        </button>
                      </div>
                    </div>
                    <div class="top-row row-no-padding w-100 row col-12">
                      <div v-show="showPotentialCount" class="text-left potential-count">{{ $t('views.createautoinvest.potentialLoans') }}<span class="count">{{ potentialResultsCount !== '-' ? potentialResultsCount : '' }}</span>
                        <square-loader v-if="potentialResultsCount==='-'"></square-loader>
                      </div>
                      <div class="text-right top-btns reset-filter" v-show="strategyFilters.length">
                        <b-button class="clear-filter" @click="resetFilters"><img src="../assets/clear_filters.svg" alt="">{{ $t('views.createautoinvest.resetFilters') }}</b-button>
                      </div>
                      <div class="w-100">
                        <b-button variant="outline-primary w-100" @click="applyFilters">{{ $t('views.createautoinvest.showMatchingLoans') }}</b-button>
                      </div>
                    </div>
                  </template>
                <div v-if="showFilters && isLeftFiltersLoaded" class="left-filters-section">
                  <div v-for="filter in this.showFilters" v-bind:key="filter.id">
                    <filter-block v-if="!filter.advanced"
                                  :filter=filter
                                  :default-value="getDefaultFilterValue(filter)"
                                  :default-display="true"
                                  :use-enabled-filters="!strategyId"
                                  @set-filter="setStrategyFilter"
                    ></filter-block>
                    <p v-if="isLOFilterAndDiversifyIsNotSet(filter)" class="loan-originator-filter-diversify-text">{{ $t('views.createautoinvest.forDiversificationFeature') }}</p>
                  </div>
                  <div>
                    <b-button v-b-toggle.advanced-collapse variant="outline-primary" class="advancedBtn">{{$t('filters.advanced')}} <span v-if="advancedShow">❮</span>
                      <span v-if="!advancedShow">❯</span></b-button>
                    <b-collapse :visible="advancedShow" id="advanced-collapse">
                      <div v-for="filter in this.showFilters" v-bind:key="'advanced_' + filter.id">
                        <filter-block v-if="filter.advanced"
                                      :filter=filter
                                      :default-value="getDefaultFilterValue(filter)"
                                      :default-display="true"
                                      :use-enabled-filters="!strategyId"
                                      @set-filter="setStrategyFilter"
                        ></filter-block>
                      </div>
                    </b-collapse>
                  </div>
                </div>
                </b-sidebar>
                <loader v-show="isFormLoading"/>
                <template v-if="!isFormLoading">
                <b-form @submit="createStrategy" class="strategy-form w-100">
                <div class="row w-100">
                  <div class="col-12 mb-2">
                    <b-form-group>
                    <b-alert show
                             v-show="Object.keys(errors).length"
                             class="errors"
                             variant="danger">
                      <ul>
                        <li
                            v-for="error in errors"
                            v-bind:key="error">
                          {{ error }}
                        </li>
                      </ul>
                    </b-alert>
                  </b-form-group>
                  </div>
                  <div class="col-12 col-md-6  mb-2">
                    <b-form-group label-for="strategy-name" :label="$t('views.createautoinvest.strategyName')">
                      <b-form-input
                          required
                          id="strategy-name"
                          v-model="strategy.name"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-12 col-md-6  mb-2">
                    <b-form-group label-for="portfolio-size">
                      <slot name="label">{{ $t('views.createautoinvest.portfolioSize') }}
                        <help-tooltip tooltipText="views.createautoinvest.setTheMaxPortfolioSize"></help-tooltip>
                      </slot>
                      <b-form-input
                          required
                          type="number" step="any"
                          :class="[ 'portfolio_size' in this.errors ? 'invalid' : '' ]"
                          v-model="strategy.portfolio_size"
                          min="0.01"
                          @keypress="isNumber($event)">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-12 col-md-6  mb-2">
                    <b-form-group>
                      <slot name="label">{{ $t('views.createautoinvest.investmentInOneLoan') }}
                         <help-tooltip tooltipText="views.createautoinvest.defineTheAmount"></help-tooltip>
                      </slot>
                      <b-input-group>
                        <b-form-input
                            required
                            type="number" step="any"
                            :placeholder="$t('views.createautoinvest.min')"
                            :class="[ 'min_amount_per_loan' in this.errors ? 'invalid' : '' ]"
                            v-model="strategy.min_amount_per_loan"
                            min="0.01"
                            v-bind:max="strategy.portfolio_size"
                            @keypress="isNumber($event)">
                        </b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </div>
                  <div class="col-12 col-md-6 mobile-max mb-2">
                    <b-form-group>
                      <slot name="label">&nbsp;</slot>
                      <b-form-input
                          required
                          type="number" step="any"
                          :placeholder="$t('views.createautoinvest.max')"
                          :class="[ 'max_amount_per_loan' in this.errors ? 'invalid' : '' ]"
                          v-model="strategy.max_amount_per_loan"
                          v-bind:min="strategy.min_amount_per_loan"
                          v-bind:max="strategy.portfolio_size"
                          @keypress="isNumber($event)">
                      </b-form-input></b-form-group>
                  </div>
                  <div class="col-12 mb-2">
                    <b-form-group>
                      <b-form-checkbox
                          name="reinvest_funds"
                          class="checkbox"
                          v-model="strategy.reinvest_funds">{{ $t('views.createautoinvest.reinvest') }}<help-tooltip tooltipText="views.createautoinvest.reinvestTooltip"></help-tooltip>
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group>
                      <b-form-checkbox
                          name="diversify"
                          class="checkbox"
                          v-model="strategy.diversify">{{ $t('views.createautoinvest.diversifyEquallyBy') }}<help-tooltip tooltipText="views.createautoinvest.diversifyTooltip"></help-tooltip>
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group>
                      <b-form-checkbox
                          required
                          name="accept_terms"
                          class="checkbox"
                          v-model="strategy.accept_terms"
                          :class="[ 'accept_terms' in this.errors ? 'invalid' : '' ]">{{ $t('views.createautoinvest.iAcceptThe') }}&nbsp;<b-link id="assignment-agreements-link">{{ $t('views.createautoinvest.assignmentAgreements') }}</b-link>
                      </b-form-checkbox>
                      <b-popover target="assignment-agreements-link" placement="top">
                        <ul class="assignment-agreements-list">
                          <li v-for="agreement in filteredAssignmentAgreements" :key="agreement.loan_originator_id">
                            <b-link target="_blank" :href="agreement.lo_assignment_agreement_link">{{ $t('views.createautoinvest.assignmentAgreement', { '1': agreement.loan_originator_name }) }}</b-link>
                          </li>
                        </ul>
                      </b-popover>
                    </b-form-group>
                  </div>
                  <div class="col-12  mb-2">
                    <div class="set-filter-block">
                      <b-button type="submit" variant="primary" :disabled="isDiversifiedButNoLOs()">{{ $t('views.createautoinvest.saveAndActivate') }}</b-button>
                      <button type="button" @click="$router.go(-1)" class="btn cancel-btn">{{ $t('views.createautoinvest.cancel') }}</button>
                    </div>
                  </div>
                </div>
                </b-form>
                </template>
              </div>
              <div class="income-box">
              <b-table hover
                       ref="invest"
                       :current-page="currentPage"
                       :per-page="perPage"
                       :items="loadLoansData"
                       :busy="isTableItemsLoading"
                       :fields="tableFields"
                       class="invest-table"
                       responsive
              >
                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <loader></loader>
                  </div>
                </template>
                <template v-slot:head()="data">
                  <span class="table-header">{{ $t(data.label) }}</span>
                </template>
                <template v-slot:cell(id)="{ item }">
                  <router-link :to="{ path: '/loan/'+ item.loan_ref }">{{ item.loan_ref }} <br> {{ item.loan_type }}</router-link>
                </template>
                <template v-slot:cell(loan_buyback_date)="{ item }">
                  {{ showDiffInTermFormat(item.loan_buyback_date, new Date().toDateString()) }}
                </template>
                <template v-slot:cell(originator)="{ item }">
                  {{ item.loan_originator_name }}
                  <!--                  / {{ item.originator_rating }}-->
                </template>
                <template v-slot:cell(country)="{ value }">
                  <img class="flag" :src="getFlag(value)" alt=""/>
                </template>
                <template v-slot:head(available_amount)="data">
                  <div class="text-right table-header">{{ $t(data.label) }}</div>
                </template>
                <template v-slot:cell(available_amount)="{ value }">
                  <div class="text-right">{{ value | moneyFormatter }}</div>
                </template>
                <template v-slot:head(loan_issued_amount)="data">
                  <div class="text-right table-header">{{ $t(data.label) }}</div>
                </template>
                <template v-slot:cell(loan_issued_amount)="{ item }">
                  <div class="text-right">{{ item.loan_issued_amount | moneyFormatterWithCurrency(item.loan_currency) }}</div>
                </template>
                <template v-slot:cell(loan_term_period)="{ item }">
                  {{ showDiffInTermFormat(item.loan_due_date, new Date().toDateString()) }}
                </template>
                <template v-slot:cell(loan_investor_interest_rate)="{ value }">
                  {{ value }}
                </template>
                <template v-slot:cell(loan_due_date)="{ value }">
                  {{ showDiffInTermFormat(value, new Date()) }}
                </template>
              </b-table>
              <div>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BeforeFormHeader from '../components/BeforeFormHeader'
import Loader from '../components/Loader'
import moneyMixin from '../mixins/money'
import flagMixin from '../mixins/flag'
import filtersMixin from '../mixins/filters'
import FilterBlock from '../components/Filter'
import loans from '@/api/loans'
import classificatorDataHelper from '@/helpers/classificatorDataHelper'
import dateMixin from '../mixins/date'
import loadingMixin from '../mixins/loading'
import SquareLoader from '@/components/SquareLoader'
import autoinvest from '@/api/autoinvest'
import HelpTooltip from '@/components/HelpTooltip'
import apiHelper from '@/helpers/apiHelper'

export default {
  components: {SquareLoader, FilterBlock, Loader, BeforeFormHeader, HelpTooltip},
  mixins: [moneyMixin, flagMixin, filtersMixin, dateMixin, loadingMixin],
  data()
  {
    return {
      investor: null,
      isLoading: true,
      isTableItemsLoading: false,
      isFormLoading: false,
      isLeftFiltersLoaded: false,
      assignmentAgreementLinks: [],
      tableFields: [
        {key: 'country', label: '', class: 'table-header', visible: true},
        {key: 'id', label: 'views.createautoinvest.table.id', class: 'table-header', visible: true},
        {key: 'originator', label: 'views.createautoinvest.table.originator', class: 'table-header', visible: true},
        {key: 'loan_investor_interest_rate', label: 'views.createautoinvest.table.interest', formatter: 'showAsPercentages', class: 'table-header', visible: true},
        {key: 'loan_term_period', label: 'views.createautoinvest.table.term', class: 'table-header', visible: true},
        {key: 'loan_buyback_date', label: 'views.loan-details.buybackDate', class: 'table-header', visible: true},
        {key: 'loan_issued_amount', label: 'views.createautoinvest.table.loanAmount', class: 'table-header', visible: true},
        {key: 'available_amount', label: 'views.createautoinvest.table.availableAmount', class: 'table-header', visible: true}
      ],
      strategyId: null,
      strategy: {
        name: null,
        portfolio_size: null,
        min_amount_per_loan: null,
        max_amount_per_loan: null,
        reinvest_funds: false,
        diversify: false,
        active: true,
        accept_terms: null
      },
      strategyFilters: [],
      rightPanel: {},
      totalRows: 20,
      currentPage: 1,
      perPage: 20,
      filterName: '',
      filterNameState: null,
      submittedNames: [],
      potentialResultsCount: '-',
      showPotentialCount: false,
      resetFilter: false,
      errors: {},
      advancedShow: false
    }
  },
  mounted()
  {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'advanced-collapse')
      {
        this.advancedShow = isJustShown
      }
    })
  },
  computed: {
    filteredAssignmentAgreements() {
      const currentLOFilter = this.getCurrentLOFilter()

      if (!currentLOFilter || this.isInDefaultState(currentLOFilter) || !this.assignmentAgreementLinks) {
        return this.assignmentAgreementLinks
      }

      const loIDs = currentLOFilter.values.map((filter) => filter.value)

      return this.assignmentAgreementLinks.filter((assignmentAgreement) => loIDs.includes(assignmentAgreement.loan_originator_id))
    },
  },
  watch:
    {
      strategyFilters:
      {
        handler(strategyFilters)
        {
          if (!this.resetFilter)
          {
            this.reloadPotentialCount(strategyFilters)
          }
          this.$forceUpdate()
        },
        deep: true
      },
      'strategy.min_amount_per_loan':
      {
        handler()
        {
          this.reloadPotentialCount(this.strategyFilters)
          this.$forceUpdate()
        },
        deep: true
      },
      loaded: function ()
      {
        this.isLoading = !this.loaded
        this.investor = this.$store.state.investors.investor

        apiHelper.request('assignment-agreements').then((response) => {
          this.assignmentAgreementLinks = response
          this.$forceUpdate()
        })

        this.isFormLoading = true
        const strategyId = this.$route.params.id
        if (strategyId) {
          this.strategyId = strategyId

          autoinvest.getDetails(strategyId)
            .then(response =>
            {
              this.strategyId = response.id
              this.strategy.name = response.name
              this.strategy.portfolio_size = response.portfolio_size
              this.strategy.min_amount_per_loan = response.min_amount_per_loan
              this.strategy.max_amount_per_loan = response.max_amount_per_loan
              this.strategy.reinvest_funds = response.reinvest_funds
              this.strategy.diversify = response.diversify

              this.strategyFilters = response.loan_filters
              this.isLeftFiltersLoaded = true
              this.applyFilters()

              this.isFormLoading = false
            })
            .catch(error =>
            {
              console.log(error)
              this.isFormLoading = false

              this.$router.push('/invest?tab=2')
            })
            .finally(() => {
              this.isLoading = false
            })
          return
        }
        else
        {
          this.isLeftFiltersLoaded = true
        }

        const useFilters = this.$route.query['use-filters']

        if (useFilters) {
          this.strategyFilters = (this.$store.state.filters.enabledFilters ?? []).filter(f => !this.isInDefaultState(f))
        }

        this.isFormLoading = false
      }
    },
  methods: {
    reloadPotentialCount(enabledFilters, emptyFilter = false)
    {
      if (enabledFilters.length > 0 || emptyFilter === true) {
        this.showPotentialCount = true
        this.potentialResultsCount = '-'
        loans.getLoansCountAfterFilters(enabledFilters ?? [], this.strategy.min_amount_per_loan).then((response) => {
          if (response && response.count >= 0) {
            this.potentialResultsCount = parseInt(response.count)
          }
        }).catch(error => {
          this.showPotentialCount = false
          console.log(error)
        })
      }
    },
    loadLoansData(ctx)
    {
      let filters = this.strategyFilters
      // console.log('Send filters:', filters)
      if (this.resetFilter) {
        filters = []
        this.resetFilter = false
      }
      const promise = loans.getLoansPage(ctx.currentPage, filters, this.strategy.min_amount_per_loan)

      return promise.then((response) =>
      {
        this.totalRows = response.loanCount
        response.loanList.forEach((loan, index, loanList) =>
        {
          loanList[index].country = classificatorDataHelper.getShortNameById('COUNTRY', loan.loan_country_id)
          loanList[index].loan_type = classificatorDataHelper.getNameById('LOAN_TYPE', loan.loan_type_id)
          loanList[index].available_amount = loan.investable_amount
        })
        return (this.filterItems(response.loanList))
      }).catch(error =>
      {
        console.log(error)
        return []
      })
    },
    isNumber: function (evt)
    {
      evt = (evt) || window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46)
      {
        evt.preventDefault()
      }
      else
      {
        return true
      }
    },
    createStrategy(event)
    {
      event.preventDefault()
      if (this.isDiversifiedButNoLOs())
      {
        return
      }

      this.isFormLoading = true
      this.errors = {}

      const strategyInfo = this.strategy
      strategyInfo.loan_filters = this.strategyFilters

      let promise
      if (this.strategyId) {
        promise = autoinvest.updateStrategy(this.strategyId, strategyInfo)
      } else {
        promise = autoinvest.createStrategy(strategyInfo)
      }

      promise.then(response =>
        {
          this.isFormLoading = false

          // reset filters for update strategy filters options
          this.$store.dispatch('filters/clearFilters')
          this.$store.dispatch('filters/fetchFilters')

          this.scrollToTop()
          this.$router.push('/invest?tab=2')
        }
      ).catch((error) => {
        this.isFormLoading = false

        if (error.response && error.response.data && error.response.data.errors) {
          for (const err in error.response.data.errors) {
            this.errors[err] = error.response.data.errors[err][0]
          }
          // error.response.data.errors.forEach(error => )
          return
        }
        this.errors[0] = 'Something went wrong. Please try again later.'
        console.log(error)
      })
    },
    setStrategyFilter(filter)
    {
      const newFilter = {id: filter.id, values: filter.values}
      const filterIndex = this.strategyFilters.findIndex(x => parseInt(x.id) === parseInt(filter.id))

      // For single select-list values
      if (typeof filter.values === 'object' && filter.values !== null && !Array.isArray(filter.values) && !filter.values.values)
      {
        filter.values = [filter.values]
        newFilter.values = filter.values
      }

      // Disable duplicates of filters
      if (filterIndex === -1)
      {
        if (
          ((Array.isArray(filter.values) || typeof filter.values === 'string') && filter.values.length > 0) ||
          (typeof filter.values === 'boolean')
        )
        {
          this.strategyFilters.push(newFilter)
        }
      }
      else
      {
        // Structure changed on BE. This fix for situation when user set custom filter twice and more
        if (filter.values && filter.values.values && filter.values.values.length)
        {
          filter.values = filter.values.values
        }
        if (!filter.values || (filter.values && filter.values.length === 0))
        {
          this.strategyFilters.splice(filterIndex, 1)
        }
        else
        {
          if (this.strategyFilters[filterIndex].values !== filter.values)
          {
            this.strategyFilters[filterIndex].values = filter.values
          }
        }
      }
    },
    isInDefaultState(filter)
    {
      const defaultFilter = this.$store.state.filters.filters.filters.find(x => parseInt(x.id) === parseInt(filter.id))
      if (!defaultFilter)
      {
        return true
      }

      if (['multiselect', 'boolean'].includes(defaultFilter.type)) {
        return !filter.values.length
      }

      if (['range'].includes(defaultFilter.type)) {
        return filter.values.length === defaultFilter.range.length && filter.values.every((value, index) => value === defaultFilter.range[index])
      }

      return false
    },
    getDefaultFilterValue(filter)
    {
      return this.strategyFilters.find(f => parseInt(f.id) === parseInt(filter.id))?.values
    },
    checkFormValidity()
    {
      const valid = this.$refs.form.checkValidity()
      this.filterNameState = valid
      return valid
    },
    resetFilters()
    {
      this.resetFilter = true
      this.$root.$emit('resetInvestFilters')
      this.applyFilters()
      this.strategyFilters = []
      this.reloadPotentialCount(this.strategyFilters, true)
      // console.log('TODO RESET FILTERS')
    },
    applyFilters()
    {
      if (this.$refs.invest)
      {
        this.$refs.invest.refresh()
        this.scrollToTop()
      }
    },
    scrollToTop()
    {
      window.scrollTo(0, 0)
    },
    getCurrentLOFilter()
    {
      return this.strategyFilters.find(f => parseInt(f.id) === parseInt(this.getLoanOriginatorFilter()?.id))
    },
    getLoanOriginatorFilter()
    {
      return this.showFilters.find(f => classificatorDataHelper.getShortNameById('FILTER_FIELD', f.field) === 'originator')
    },
    setLoanOriginatorFilter()
    {
      const loanOriginatorFilter = this.getLoanOriginatorFilter()
      if (loanOriginatorFilter && this.strategyFilters.findIndex(f => parseInt(f.id) === parseInt(loanOriginatorFilter.id)) === -1)
      {
        this.strategyFilters.push({
          id: loanOriginatorFilter.id,
          values: loanOriginatorFilter.options
        })
      }
    },
    isLOFilterAndDiversifyIsNotSet(filter)
    {
      const currentLOFilter = this.getCurrentLOFilter()
      const loanOriginatorFilter = this.getLoanOriginatorFilter()
      return this.strategy.diversify && loanOriginatorFilter && parseInt(loanOriginatorFilter.id) === parseInt(filter.id) && (!currentLOFilter || currentLOFilter.values.length === 0)
    },
    isDiversifiedButNoLOs()
    {
      return this.showFilters.filter(filter => this.isLOFilterAndDiversifyIsNotSet(filter)).length > 0
    }
  }
}
</script>

<style src="../../node_modules/vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style lang="scss">
.multiselect__tags-wrap .multiselect__tag {
  background: #30A7FE !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #30A7FE !important;
  background-color: #30A7FE !important;
}

.strategy-form{
  .custom-checkbox .custom-control-label {
    font-size: 17px;
    padding-left: 7px;
    cursor: pointer;
    margin-bottom: 5px;
    display: block;
  }
  .mobile-max{
    @media (max-width: 768px) {
      margin-top: -40px;
    }
  }
}
</style>
<style lang="scss" scoped>
.filter {
  //border-bottom: 1px solid #E5E9ED;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: #000000;
    margin-bottom: 16px;
    margin-top: 15px;
  }

  .dots {
    float: right;
  }

  hr {
    background: #E5E9ED;
  }
}

.right-col {
  background: #FFFFFF;
  border-radius: 4px;
  min-height: 359px;
  text-align: center;

  .bottom-note{
    display: inline-block
  }
}

.right-filters {

  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: left;
  padding: 20px;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #000000;
  }

  .value {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
  }

  img {
    min-height: 15px;
  }
}

.small-stepper {
  font-size: 11px;
  font-weight: bold;
  line-height: 20px;
  margin: 20px auto 0 3px;
}

.invest-table {
  font-size: 11px !important;
}

.flag {
  width: 16px;
}

.table-header {
  font-style: normal;
  font-weight: bold;
  font-size: 8px;
  line-height: 10px;
  text-align: center;
  text-transform: uppercase;
  color: #9DA0A6;
}

.toggle-details-btn {
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  color: #9DA0A6;
  background-color: transparent;
  border: none;
}

.invest-btn {
  border: 2px solid #30A7FE;
  box-sizing: border-box;
  border-radius: 16px;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  align-items: center;
  text-align: center;
  color: #000000;
  mix-blend-mode: normal;
  opacity: 0.8;
  margin-right: 3px;
}

.end-range-title {
  float: right;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: #000000;
}

.start-range-title {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #000000;
}

.invest-ig {
  border: 1px solid #D6D6D6;
  border-radius: 16px;
  width: 100px;
  margin: 2px;
  padding: 2px;
  font-style: normal;
  font-weight: normal;
  font-size: 11px !important;
  line-height: 20px;
  float: left;

  .prepend {
    margin-left: 3px;
  }

  .invest-input, .invest-input:focus, .invest-input:hover {
    max-width: 100px;
    border: none;
    border-radius: 0;
    background: transparent;
    height: 20px;
    outline: 0;
    box-shadow: none;
    font-size: 11px !important;
  }

  .append {
    float: right;
    cursor: pointer;
    padding-right: 5px;
  }
}

.remove-invest {
  background: transparent;
  border: none;
  float: right;
  cursor: pointer;
  padding: 1px;
}

.invest-form {
  display: inline-flex;

  .invalid {
    color: red;
    font-weight: bold;
  }
}

.invest-section {
  min-width: 85px;
}

.loan-details {
  float: right;
  background: #30A7FE;
  border-radius: 14px;
  border-color: transparent;
  font-size: 11px;
}

.set-favorite-filter {
  border: 2px solid #30A7FE;
  box-sizing: border-box;
  border-radius: 50px;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 20px;
  color: #000000;
  float: right;
  margin: 2px;
  background: transparent;
}

.top-btns {
  display: inline-block;

  .clear-filter {
    display: inline-flex;
    border: none;
    box-sizing: border-box;
    border-radius: 50px;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
    color: #000000;
    float: right;
    margin: 5px;
    background: transparent;
    box-shadow: none;

    img {
      max-width: 25px;
    }
  }
}

.dual-input {
  & > div {
    display: flex;
  }
}

.back-button {
  margin-top: 25px;
  margin-bottom: 25px;
  color: #000000;
}

.save-and-activate {
  background: #30A7FE;
  border: 1px solid #30A7FE;
}

.show-matching-loans {
  background: #FFFFFF;
  border: 1px solid #30A7FE;
  color: #30A7FE;
}

.use-filters {
  padding: 10px 15px;
  border-radius: 15px;
  margin-top: 25px;
  margin-bottom: 50px;
}

.set-filter-block {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;

  & > .btn {
    font-size: 13px;
    margin-left: 5px;

    &:first-child {
      margin-left: 0px;
    }
  }
}

.apply-filter {
  background: #30A7FE;
  border: 1px solid #30A7FE;
  color: white;
  border-radius: 50px;
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  line-height: 20px;
  margin: 2px;
  box-shadow: none;
}

.reset-filter{
  width: 45%;
  button {
    padding: 5px;
  }
  margin-bottom: 5px;
}
.top-row{
  padding-left: 0;
  padding-right: 5px;
}
.potential-count {
  font-style: normal;
  //font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.02em;
  display: inline-block;
  padding-top: 10px;
  margin-bottom: 5px;
  width: 55%;

  .count {
    font-size: 18px;
    font-weight: bold;
  }
}

.strategy-form {
  margin-top: 20px;
}

.invalid {
  color: red;
  border-color: red;
}

.errors {
  font-size: 13px;
  margin: 0px;
  padding: 15px 5px 0px;

  & > ul {
    padding: 0px 0px 0px 15px;

    & > li {
      margin-left:0px;
      margin-bottom: 5px;
    }
  }
}
#assignment-agreements-link {
  white-space: nowrap;
}

.assignment-agreements-list {
  padding: 6px;
  margin: 0px;

  & > li {
    list-style-type: none;
    margin-left:0px;
    margin-bottom: 8px;
  }

  & > li:last-child {
    margin-bottom: 0px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.loan-originator-filter-diversify-text {
  margin-top: 5px;
  color: red;
  font-size: 13px;
}

.advancedBtn, .advancedBtn:hover, .advancedBtn:focus {
  margin-top: 10px;
  font-weight: bold;
  color: #30A7FE !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  font-size: 14px;
  padding-left: 0;
}
</style>
